export function htmlEncodeByRegExp(str: string): string {
  if (str.length == 0) return ''
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br/>')
}
